export enum RoleList {
  VIEWER = 'VIEWER',
  Admin = 'ADMIN',
  SuperUser = 'SUPER_USER',
  FilmMaker = 'FILM_MAKER',
}
